import { showSearchMsg, showUploadMsg, editReportMsg, showModalMsg, showFrontPageMsg, showLoginMsg } from '../Update';
import hh from 'hyperscript-helpers';
import { h } from 'virtual-dom';
import {uploadView} from "./UploadView";
import {detailView} from "./DetailView";
import {loginView} from "./LoginView";
import {formView, resultView} from "./SearchView";
import {frontPageView} from "./FrontPageView";

const { div, h2, nav, a, li, pre, p, header, img, input, label, i, ul, button, span } = hh(h);

function loadKeywords(dispatch, msg) {
    setTimeout(function() {
        dispatch(msg);
    }, 800);
    return div({ className: 'mv3 f4 tc i black-50' }, ('Loader...'));
}

function determineState(dispatch, model) {
    switch (model.state) {
        case 'frontPage': return [
            frontPageView(dispatch, model),
        ];
        case 'login': return [
            loginView(dispatch, model),
        ];
        case 'orderPin': return [
            loginView(dispatch, model),
        ];
        case 'search': {
            if (model.constLists.searchKeywords.length === 0) return loadKeywords(dispatch, showSearchMsg);
            return [
                formView(dispatch, model),
                resultView(dispatch, model),
            ];
        }
        case 'detail': return [
            detailView(dispatch, model),
        ];
        case 'upload': {
            if (model.constLists.searchKeywords.length === 0) return loadKeywords(dispatch, showUploadMsg);
            return [ uploadView(dispatch, model) ];
        }
        case 'edit': {
            if (model.constLists.searchKeywords.length === 0) return loadKeywords(dispatch, editReportMsg);
            return [ uploadView(dispatch, model) ];
        }
    }
}

function navigation(dispatch, model) {
    return div( {}, [
        img( { className: 'fr', src: 'https://data.geus.dk/JupiterWWW/images/geuslogo.png' }, ),
        header( { className: 'bg-light-gray br2 w-90-l w-80-m w-60 pv2 ph2' }, [
            nav( { className: 'db dt-l w-100 border-box ph1 ph2-l pv0'}, [
                p({ className: 'gray f4-ns f5 mv0'}, 'Grundvandsrapporter'),
                div( { className: 'db dtc-l v-mid w-100 w-75-l tc tr-l' } , [
                    menuLink(dispatch, showFrontPageMsg, 'Forside'),
                    menuLink(dispatch, showSearchMsg, 'Søg i grundvandsdatabasen'),
                    menuLink(dispatch, showUploadMsg, 'Indsend rapport'),
                    model.login.loggedin ? menuLink(dispatch, showLoginMsg, i( { className: 'bg-animate hide-child fa fa-sign-out' }, span({className: 'db absolute top-2 mt3 z-1 bg-white ba br2 b--moon-gray pa2 shadow-5 child'}, p({ className: 'f6 blue b sans-serif ma0'},'Log ud') ) ) ) : '',
                ])
            ]),
        ])
    ]);
}

function menuLink(dispatch, dispatchMsg, title) {
    return a( { className: 'link pointer dim blue f6 f5-l dib mr3 mr4-l', onclick: () => dispatch(dispatchMsg) } , title);
}

function view(dispatch, model) {
    const formByState = determineState(dispatch, model);
    const nav = navigation(dispatch, model);
    return div({ className: 'fade' }, [
        nav,
        formByState
    ]);
}

const btnDisabledClassName = 'ph3-ns ph2 pv2-ns pv1 input-reset ba br2 gray b--gray bg-light-gray f5-ns f6 submitdisabled';
const btnClassName = 'ph3-ns ph2 pv2-ns pv1 input-reset ba br2 white b--blue bg-blue hover-bg-dark-blue pointer f5-ns f6';
export function getSubmitButton(title, btnDisabled) {
   return btnDisabled ?
       button({ className: btnDisabledClassName, type: 'submit', disabled: btnDisabled }, title) :
       button({ className: btnClassName, type: 'submit' }, title);
}
export function getButton(title, className, btnDisabled, dispatch, dispatchMsg) {
   return btnDisabled ?
       button({ className: (btnDisabledClassName+className), type: 'button', disabled: btnDisabled }, title) :
       button({ className: (btnClassName+className), type: 'button', onclick: e => dispatch(dispatchMsg) }, title);
}

export default view;